export const LS_ADMIN_TOKEN = "bnm-admin-token";
const EVT = "bnm-admin-auth";

const isExpired = (t) => {
  try {
    const payload = JSON.parse(atob(t.split(".")[1]));
    if (!payload.exp) return false;
    return payload.exp * 1000 <= Date.now();
  } catch {
    return true; // unparseable / garbage token → treat as invalid
  }
};

export const getAdminToken = () => {
  const t = localStorage.getItem(LS_ADMIN_TOKEN) || "";
  if (t && isExpired(t)) {
    localStorage.removeItem(LS_ADMIN_TOKEN);
    return "";
  }
  return t;
};

export const setAdminToken = (t) => {
  localStorage.setItem(LS_ADMIN_TOKEN, t);
  window.dispatchEvent(new Event(EVT));
};

export const adminLogout = () => {
  localStorage.removeItem(LS_ADMIN_TOKEN);
  window.dispatchEvent(new Event(EVT));
};

export const onAdminAuthChange = (cb) => {
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
};
